import { render } from "./TapTheBodyPart.vue?vue&type=template&id=4d1008e0&scoped=true"
import script from "./TapTheBodyPart.vue?vue&type=script&lang=js"
export * from "./TapTheBodyPart.vue?vue&type=script&lang=js"

import "./TapTheBodyPart.vue?vue&type=style&index=0&id=4d1008e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1008e0"]])

export default __exports__